Namespace 'Monitoring.Reports.SocialListening'

class Monitoring.Reports.SocialListening.HeaderView extends Backbone.View
  className: 'header'
  template: JST['backbone/templates/monitoring/reports/social_listening/header']

  events:
    'click #build': 'build'

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    @$el.html(@template(@options))
    threeYearsAgo = new Date()
    threeYearsAgo.setFullYear(threeYearsAgo.getFullYear() - 3)
    @$('.date').datepicker(
      autoclose: true
      startDate: threeYearsAgo
      endDate: new Date()
      format: 'dd/mm/yyyy'
      todayBtn: 'linked'
      todayHighlight: true
    )
    @$el.find('#select-nodes').chosen(width: '100%', disable_search_threshold: 10, inherit_select_classes: true)

  build: =>
    params = {
      from: @$('#from').val(),
      to: @$('#to').val(),
      nodes: @$('#select-nodes').val()
    }
    @change_enable(false)
    exportJob = new Monitoring.Methods.AsyncJob()
    exportJob.bind('completed', (results) => @_onComplete(results))
    exportJob.bind('failed', (results) => @_onFailure(results))
    exportJob.start "social_listening", params
    @$(".loading-report")[0].style.display = 'inline-flex'

  _onComplete: (results) =>
    $form = $("<form action='#{results.path}' method='get'></form>").addClass('hidden')
    @$el.append($form)
    $form.submit()
    @reableOptions()

  _onFailure: (message) =>
    showError("There was a problem making your report")
    @reableOptions()

  reableOptions: =>
    @$(".loading-report").hide()
    @change_enable(true)

  change_enable:(value) =>
    value = !value
    @$('#from').attr('disabled', value)
    @$('#to').attr('disabled', value)
    @$('#select-nodes').attr('disabled', value).trigger("chosen:updated");
    @$('#build').attr('disabled', value)
